import React from 'react'
import { OmForm, OmFormItem, OmCheckbox, OmInput, OmButton, omMessage } from '@owma/kit'

import i18n from 'i18n'
import classNames from 'classnames'
import { store as reduxStore } from 'index'
import { SIGNATURE_TITLE_MAX_LENGTH, truncateSignatureTitle } from 'utils/signatureTitle'

import {
  confirmBase,
  // dragPopup
} from 'utils/ui'

import dataManager from 'pages/main/data/DataManager'
import SignatureList from 'popups/component/SignatureList'
import SignatureEdit from 'popups/component/SignatureEdit'
// import { editorType } from 'vars'
import styles from './style.module.scss'

// NgwEditor 모드에서는 데스크탑 toolbar 가 768px 임계 (window.innerWidth 기준) 이하에서만 모바일
// 모드로 전환되어, 640px popup 안에서 toolbar 가 wrap 안 되고 깨진다. NgwEditor 의 임계 + buffer
// 확보를 위해 popup width 를 800px 로 늘림. TinyMCE 모드 (롤백 경로) 는 기존 640px 유지.
const SIGNATURE_EDIT_WIDTH = 640 // editorType === 'ngw' ? 800 : 640

interface RenamePopupOptions {
  title: string
  fieldName: string
  placeholder?: string
  description?: string
  value?: string
  okText?: string
  cancelText?: string
  onOk?: (closeFunc: () => void, newName: string) => void
}

export function renamePopup(options: RenamePopupOptions): void {
  const tmpObj: any = {
    title: options.title,
    fieldName: options.fieldName,
    placeholder: options.placeholder,
    description: options.description,
    value: options.value || '',
    formRef: React.createRef<any>(),
    btnDisabled: true,
    ref: null,
  }

  tmpObj.onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    console.log(e)
    const text = e.target.value
    if (text.trim().length > 0 && text !== tmpObj.value) {
      tmpObj.btnDisabled = false
    } else {
      tmpObj.btnDisabled = true
    }

    tmpObj.newName = text

    tmpObj.updateModal()
  }

  tmpObj.onOk = (closeFunc: () => void): void => {
    if (options.onOk != null) {
      options.onOk(closeFunc, tmpObj.newName)
    } else {
      closeFunc()
    }
  }

  tmpObj.onPressEnter = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    console.log(' --- onPressEnter : ', e)
    if (tmpObj.btnDisabled !== true) {
      tmpObj.onOk()
      tmpObj.modalObj.destroy()
    }
  }

  tmpObj.setRef = (ref: any): void => {
    if (tmpObj.ref == null && tmpObj.ref !== ref) {
      tmpObj.ref = ref
      console.log(' --- setRef : ', ref)
      setTimeout(() => {
        tmpObj.ref.select()
      }, 100)
    }
  }

  tmpObj.render = (): React.ReactElement => {
    const formAttrs = {
      className: classNames('line-form'),
      layout: 'vertical' as const,
      requiredMark: false,
      ref: tmpObj.formRef,
      initialValues: { newName: tmpObj.value },
    }

    const descElem = tmpObj.description != null ? <div>{tmpObj.description}</div> : null
    return (
      <React.Fragment>
        {descElem}
        <OmForm {...formAttrs}>
          <OmFormItem
            name="newName"
            label={tmpObj.fieldName}
            rules={[{ required: true, message: '' }]}
          >
            <OmInput
              ref={tmpObj.setRef}
              autoFocus={true}
              maxLength={SIGNATURE_TITLE_MAX_LENGTH}
              placeholder={tmpObj.placeholder}
              onChangeEvent={tmpObj.onChange}
              onKeyDown={(e) => {
                if (e.key === 'Enter') tmpObj.onPressEnter(e)
              }}
            />
          </OmFormItem>
        </OmForm>
      </React.Fragment>
    )
  }

  tmpObj.modalObj = confirmBase({
    wrapClassName: classNames(styles.renamePopup),
    className: classNames('mobile-fullpage'),
    title: tmpObj.title,
    content: tmpObj.render(),
    okText: options.okText || i18n.t('common.button.ok'),
    cancelText: options.cancelText || i18n.t('common.button.cancel'),
    okButtonProps: { disabled: tmpObj.btnDisabled },
    width: 380,
    onOk: (closeFunc: () => void): void => {
      // item.record.set('name', tmpObj.newName)
      tmpObj.onOk(closeFunc)
    },
    afterOpenChange: (open: boolean): void => {
      console.log(' --- afterOpenChange : ', open)
    },
  })

  tmpObj.updateModal = (): void => {
    tmpObj.modalObj.updateBase({
      okButtonProps: { disabled: tmpObj.btnDisabled },
    })
  }
}

interface SetDefaultOptions {
  okText?: string
  cancelText?: string
  onOk?: (closeFunc: () => void, values: any) => void
}

export function openSetDefault(options: SetDefaultOptions): void {
  const { user } = reduxStore.getState()

  const tmpObj: any = {
    title: i18n.t('signature.title.setAsDefault'),
    description: i18n.t('signature.desc.setAsDefault', { email: user.email }),
    formRef: React.createRef<any>(),
  }

  tmpObj.onOk = (closeFunc: () => void, values: any): void => {
    if (options.onOk != null) {
      options.onOk(closeFunc, values)
    } else {
      closeFunc()
    }
  }

  tmpObj.onPressEnter = (e: React.KeyboardEvent): void => {
    console.log(' --- onPressEnter : ', e)
    if (tmpObj.btnDisabled !== true) {
      tmpObj.onOk()
      tmpObj.modalObj.destroy()
    }
  }

  tmpObj.render = (): React.ReactElement => {
    const formAttrs = {
      className: classNames('line-form'),
      // layout: 'vertical',
      // requiredMark: false,
      ref: tmpObj.formRef,
      initialValues: {
        newMessage: true,
        replyForward: true,
      },
    }

    const descElem =
      tmpObj.description != null ? <div className={styles.desc}>{tmpObj.description}</div> : null

    return (
      <React.Fragment>
        {descElem}
        <OmForm {...formAttrs}>
          <OmFormItem name="newMessage" valuePropName="checked">
            <OmCheckbox>{i18n.t('signature.btns.signatureForNew')}</OmCheckbox>
          </OmFormItem>
          <OmFormItem name="replyForward" valuePropName="checked">
            <OmCheckbox>{i18n.t('signature.btns.signatureForReplyForward')}</OmCheckbox>
          </OmFormItem>
        </OmForm>
      </React.Fragment>
    )
  }

  tmpObj.modalObj = confirmBase({
    wrapClassName: classNames(styles.setDefaultPopup),
    className: classNames('mobile-fullpage'),
    title: tmpObj.title,
    content: tmpObj.render(),
    okText: options.okText || i18n.t('common.button.ok'),
    cancelText: options.cancelText || i18n.t('common.button.cancel'),
    // okButtonProps: { disabled: tmpObj.btnDisabled },
    width: 480,
    onOk: (closeFunc: () => void): void => {
      if (tmpObj.formRef.current != null) {
        const values = tmpObj.formRef.current.getFieldsValue()
        tmpObj.onOk(closeFunc, values)
      }
      // item.record.set('name', tmpObj.newName)
    },
    afterOpenChange: (open: boolean): void => {
      console.log(' --- afterOpenChange : ', open)
    },
  })

  tmpObj.updateModal = (): void => {
    tmpObj.modalObj.updateBase({
      // okButtonProps: { disabled: tmpObj.btnDisabled },
    })
  }
}

interface EditSignatureOptions {
  title?: string
  signature?: any
  readonly?: boolean
  isNew?: boolean
  // '새 서명'으로 편집을 연 경우에만 true. '가져오기'(HTML import) 버튼 노출 여부를 결정한다.
  // 복제/편집/보기에서는 설정하지 않아 버튼이 숨겨진다.
  canImport?: boolean
  onOk?: (closeFunc: () => void, eml: any) => void
}

export function editSignature(options?: EditSignatureOptions): void {
  const opts = options || {}

  const isReadOnly = opts.readonly === true

  const tmpObj: any = {
    isNew: opts.isNew === true,
    title: opts.title || i18n.t('signature.title.editSignature'),
    btnDisabled: true,
    saveLoading: false,
    editorRef: React.createRef<any>(),
  }

  // modified true → 저장 버튼 enable, false → disable (사용자가 본문 다 지워서 원래 상태로
  // 돌아간 케이스). 매 변경 알림마다 modal 갱신.
  tmpObj.onModifiedChange = (modified: boolean): void => {
    const nextDisabled = modified !== true
    if (tmpObj.btnDisabled === nextDisabled) return
    tmpObj.btnDisabled = nextDisabled
    tmpObj.updateModal()
  }

  tmpObj.render = (): React.ReactElement => {
    const attrs = {
      innerRef: tmpObj.editorRef,
      signature: opts.signature,
      onModifiedChange: tmpObj.onModifiedChange,
      readonly: isReadOnly,
    }
    return <SignatureEdit {...attrs} />
  }

  // OFM-224: 왼쪽 'HTML 가져오기' 버튼 + 기존 저장(OkBtn)/취소(CancelBtn).
  // '새 서명'(canImport)으로 연 경우에만 노출한다(복제/편집/보기는 숨김).
  // 실제 import 로직은 SignatureEdit.importHtmlFile 이 담당 (editorRef 로 호출).
  // updateModal 에서도 재전달하여 OkBtn 의 disabled/loading 갱신이 반영되도록 한다.
  tmpObj.renderFooter = (_: any, { OkBtn, CancelBtn }: any): React.ReactElement => (
    <div className={classNames(styles.footer)}>
      <div className={classNames('btns')}>
        <OmButton
          variant="text"
          className={classNames('type5', 'h38', 'w100', styles.importBtn, {
            hidden: opts.canImport !== true,
          })}
          onClick={() => {
            tmpObj.editorRef.current?.importHtmlFile()
          }}
        >
          {i18n.t('signature.btns.import')}
        </OmButton>
        <OkBtn />
        <CancelBtn />
      </div>
    </div>
  )

  tmpObj.modalObj = confirmBase({
    wrapClassName: classNames(styles.editSignature),
    className: classNames('mobile-fullpage'),
    title: tmpObj.title,
    content: tmpObj.render(),
    okText: i18n.t('common.button.save'),
    width: SIGNATURE_EDIT_WIDTH,
    maskClosable: false,
    okButtonProps: {
      className: classNames('type1', 'h38', 'w100', { hidden: isReadOnly }),
      disabled: tmpObj.btnDisabled,
      loading: tmpObj.saveLoading,
    },
    closeButtonProps: {
      className: classNames('type5', 'h38', 'w100'),
    },
    footer: tmpObj.renderFooter,
    onOk: (closeFunc: () => void): void => {
      if (opts.onOk != null) {
        if (tmpObj.editorRef.current != null) {
          tmpObj.editorRef.current
            .createRefObj()
            .getContent()
            .then((res: any) => {
              const { eml, error, sizeExceeded } = res
              // 서명 본문이 크기 제한(500KB)을 초과하면 getContent 가 에러 모달을 띄우고
              // sizeExceeded 를 반환한다. 저장을 중단하되 편집 모달은 닫지 않아(closeFunc 미호출)
              // 사용자가 내용을 줄여 다시 저장할 수 있게 한다.
              if (sizeExceeded === true) {
                return
              }
              if (error != null) {
                console.error(' --- error : ', error)
                closeFunc()
                return
              }

              opts.onOk!(closeFunc, eml)
            })
        }
      } else {
        closeFunc()
      }
    },
  })

  // tmpObj.dragPopup = dragPopup(tmpObj);

  tmpObj.updateModal = (): void => {
    tmpObj.modalObj.updateBase({
      content: tmpObj.render(),
      footer: tmpObj.renderFooter,
      okButtonProps: {
        className: classNames('type1', 'h38', 'w100', { hidden: isReadOnly }),
        disabled: tmpObj.btnDisabled,
        loading: tmpObj.saveLoading,
      },
    })
  }
}

interface ManageSignatureOptions {
  title?: string
  afterClose?: () => void
}

export function openManageSignature(options?: ManageSignatureOptions): void {
  const opts = options || {}

  const tmpObj: any = {
    title: opts.title || i18n.t('signature.title.manageSignatures'),
    innerRef: React.createRef<any>(),
  }

  tmpObj.onClickNewSignature = (): void => {
    const signatureList = dataManager.getSignatureList()

    const existingTitles = new Set(
      signatureList.map((item: any) =>
        /* i18next-extract-disable-next-line */
        item.titleKey != null ? i18n.t(item.titleKey) : item.title,
      ),
    )

    let index = Math.max(signatureList.length, 1)
    let title = i18n.t('signature.title.editSignature', { title: `#${index}` })
    while (existingTitles.has(title)) {
      index += 1
      title = i18n.t('signature.title.editSignature', { title: `#${index}` })
    }

    const { title: finalTitle, truncated } = truncateSignatureTitle(title)
    if (truncated) {
      omMessage.info(i18n.t('signature.duplicateTruncatedNotice'))
    }

    if (tmpObj.innerRef.current != null) {
      tmpObj.innerRef.current.createSignature(finalTitle)
    }
  }

  tmpObj.render = (): React.ReactElement => {
    return <SignatureList innerRef={tmpObj.innerRef} />
  }

  tmpObj.modalObj = confirmBase({
    wrapClassName: classNames(styles.manageSignatures),
    className: classNames('mobile-fullpage'),
    title: tmpObj.title,
    content: tmpObj.render(),
    okText: i18n.t('common.button.close'),
    width: 480,
    maskClosable: false,
    okButtonProps: {
      className: classNames('type1', 'h38', 'w100'),
    },
    footer: (_: any, { OkBtn }: any): React.ReactElement => (
      <div className={classNames(styles.footer)}>
        <div className={classNames('btns')}>
          <OmButton
            variant="text"
            className={classNames('type5', 'h38', 'w100')}
            onClick={tmpObj.onClickNewSignature}
          >
            {i18n.t('signature.btns.newSignature')}
          </OmButton>
          <OkBtn />
        </div>
      </div>
    ),
    afterClose: () => {
      // tmpObj.dragPopup.removeEvent();
      if (opts.afterClose != null) {
        opts.afterClose()
      }
    },
  })

  // tmpObj.dragPopup = dragPopup(tmpObj);

  tmpObj.updateModal = (): void => {
    tmpObj.modalObj.updateBase({
      content: tmpObj.render(),
    })
  }
}

const signaturePopup = {
  renamePopup,
  editSignature,
  openManageSignature,
}

export default signaturePopup
